import { FC, SVGProps, useId } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/** Avito — официальная разметка (без белого фона). */
export const AvitoIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    fill="none"
    aria-hidden
    {...props}
  >
    <circle fill="#97CF26" cx="59" cy="59" r="16" />
    <circle fill="#0AF" cx="29" cy="29" r="13" />
    <circle fill="#FF6163" cx="59" cy="29" r="10" />
    <circle fill="#A169F7" cx="28.5" cy="58.5" r="7.5" />
  </svg>
)

/** Viber — официальная разметка. */
export const ViberIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 631.99 666.43"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      fill="#fff"
      d="M560.65,65C544.09,49.72,477.17,1.14,328.11.48c0,0-175.78-10.6-261.47,68C18.94,116.19,2.16,186,.39,272.55S-3.67,521.3,152.68,565.28l.15,0-.1,67.11s-1,27.17,16.89,32.71c21.64,6.72,34.34-13.93,55-36.19,11.34-12.22,27-30.17,38.8-43.89,106.93,9,189.17-11.57,198.51-14.61,21.59-7,143.76-22.65,163.63-184.84C646.07,218.4,615.64,112.66,560.65,65Z"
    />
    <path
      fill="#7360f2"
      d="M525.88,98.77c-14-12.72-74.43-50.69-200.52-51.24,0,0-149.31-9.81-221.79,55.84C63.23,143.2,49.64,202.43,48.15,274.71s-9.21,210.36,123,247.09h0s-.52,102.51-.58,111.52c0,6.3,1,10.61,4.6,11.5,2.59.63,6.47-.71,9.77-4,21.14-21.23,88.82-102.88,88.82-102.88,90.81,5.93,163.06-12,170.83-14.54C462.91,517.51,562,509,578.77,373.54,596.1,233.91,572.4,138.6,525.88,98.77Z"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16.86"
      d="M389.47,268.77q-2.46-49.59-50.38-52.09"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16.86"
      d="M432.72,283.27q1-46.2-27.37-77.2c-19-20.74-45.3-32.16-79.05-34.63"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16.86"
      d="M477,300.59q-.61-80.17-47.91-126.28t-117.65-46.6"
    />
    <path
      fill="#fff"
      d="M340.76,381.68s11.85,1,18.23-6.86l12.44-15.65c6-7.76,20.48-12.71,34.66-4.81A366.67,366.67,0,0,1,437,374.1c9.41,6.92,28.68,23,28.74,23,9.18,7.75,11.3,19.13,5.05,31.13,0,.07-.05.19-.05.25a129.81,129.81,0,0,1-25.89,31.88c-.12.06-.12.12-.23.18q-13.38,11.18-26.29,12.71a17.39,17.39,0,0,1-3.84.24,35,35,0,0,1-11.18-1.72l-.28-.41c-13.26-3.74-35.4-13.1-72.27-33.44a430.39,430.39,0,0,1-60.72-40.11,318.31,318.31,0,0,1-27.31-24.22l-.92-.92-.92-.92h0l-.92-.92c-.31-.3-.61-.61-.92-.92a318.31,318.31,0,0,1-24.22-27.31,430.83,430.83,0,0,1-40.11-60.71c-20.34-36.88-29.7-59-33.44-72.28l-.41-.28a35,35,0,0,1-1.71-11.18,16.87,16.87,0,0,1,.23-3.84Q141,181.42,152.12,168c.06-.11.12-.11.18-.23a129.53,129.53,0,0,1,31.88-25.88c.06,0,.18-.06.25-.06,12-6.25,23.38-4.13,31.12,5,.06.06,16.11,19.33,23,28.74a366.67,366.67,0,0,1,19.74,30.94c7.9,14.17,2.95,28.68-4.81,34.66l-15.65,12.44c-7.9,6.38-6.86,18.23-6.86,18.23S254.15,359.57,340.76,381.68Z"
    />
  </svg>
)

/** Циан — официальная разметка. */
export const CianIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 697.3 1000"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      fill="#0468FF"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M529.8,246.2c-42.5,0-76.9-34.7-76.9-77.5s34.4-77.5,76.9-77.5c42.4,0,76.8,34.7,76.8,77.5S572.2,246.2,529.8,246.2L529.8,246.2z M529.8,0c-92.6,0-167.6,75.7-167.6,169.1c-0.1,36.8,11.9,72.7,34,102.1l11.1,15.6l122.4,149l133.6-164.6c22.1-29.4,34.1-65.3,34-102.1C697.3,75.7,622.3,0,529.8,0L529.8,0z M593.7,785.6V501.9H469.6v133.3L345.5,484.7L0,903.5l114.9,96.5l230.6-279.4L576.1,1000L691,903.5L593.7,785.6z"
    />
  </svg>
)

/** Instagram — официальная разметка (уникальные id градиентов). */
export const InstagramIcon: FC<IconProps> = (props) => {
  const rawId = useId().replace(/:/g, '')
  const idA = `ig-a-${rawId}`
  const idB = `ig-b-${rawId}`
  const idC = `ig-c-${rawId}`
  const idD = `ig-d-${rawId}`
  const idE = `ig-e-${rawId}`
  const idF = `ig-f-${rawId}`
  const idG = `ig-g-${rawId}`
  const idH = `ig-h-${rawId}`

  const roundedRect =
    'M204.1503 18.1429c-55.2305 0-71.3834.057-74.5232.3175-11.3342.9424-18.387 2.7275-26.0708 6.554-5.9214 2.9413-10.5915 6.3506-15.2005 11.1298-8.3938 8.7157-13.481 19.4383-15.3226 32.1842-.8953 6.1877-1.1558 7.4496-1.2087 39.0558-.0203 10.5354 0 24.4007 0 42.9984 0 55.2008.061 71.3418.3256 74.4764.9157 11.032 2.6453 17.9728 6.3081 25.565 7 14.5329 20.369 25.4428 36.119 29.5137 5.4535 1.4044 11.4767 2.1779 19.2092 2.5442 3.2762.1425 36.6684.2443 70.081.2443 33.4127 0 66.8253-.0407 70.02-.2035 8.9535-.4214 14.1526-1.1195 19.9011-2.6054 15.8517-4.0912 28.9767-14.8383 36.119-29.5748 3.5916-7.409 5.4128-14.6144 6.237-25.0704.179-2.2796.2543-38.6263.2543-74.924 0-36.304-.0814-72.5835-.2605-74.8632-.8343-10.6249-2.6555-17.7692-6.363-25.3207-3.0421-6.1816-6.42-10.798-11.324-15.518-8.752-8.3616-19.4555-13.4502-32.2101-15.2902-6.18-.8936-7.411-1.1582-39.033-1.2131z'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 264.5833 264.5833"
      width="1000"
      height="1000"
      fill="none"
      aria-hidden
      {...props}
    >
      <defs>
        <linearGradient id={idD}>
          <stop offset="0" stopColor="#ff005f" />
          <stop offset="1" stopColor="#fc01d8" />
        </linearGradient>
        <linearGradient id={idC}>
          <stop offset="0" stopColor="#780cff" />
          <stop offset="1" stopColor="#820bff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={idB}>
          <stop offset="0" stopColor="#fc0" />
          <stop offset="1" stopColor="#fc0" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={idA}>
          <stop offset="0" stopColor="#fc0" />
          <stop offset=".1242" stopColor="#fc0" />
          <stop offset=".5672" stopColor="#fe4a05" />
          <stop offset=".6942" stopColor="#ff0f3f" />
          <stop offset="1" stopColor="#fe0657" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id={idF}
          cx="158.429"
          cy="578.088"
          r="52.3515"
          xlinkHref={`#${idA}`}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 -4.03418 4.28018 0 -2332.2273 942.2356)"
          fx="158.429"
          fy="578.088"
        />
        <radialGradient
          id={idG}
          xlinkHref={`#${idB}`}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.67441 -1.16203 1.51283 .87801 -814.3657 -47.8354)"
          cx="172.6149"
          cy="600.6924"
          fx="172.6149"
          fy="600.6924"
          r="65"
        />
        <radialGradient
          id={idH}
          xlinkHref={`#${idC}`}
          cx="144.012"
          cy="51.3367"
          fx="144.012"
          fy="51.3367"
          r="67.081"
          gradientTransform="matrix(-2.3989 .67549 -.23008 -.81732 464.9957 -26.4035)"
          gradientUnits="userSpaceOnUse"
        />
        <radialGradient
          id={idE}
          xlinkHref={`#${idD}`}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-3.10797 .87652 -.6315 -2.23914 1345.6503 1374.1983)"
          cx="199.7884"
          cy="628.4379"
          fx="199.7884"
          fy="628.4379"
          r="52.3515"
        />
      </defs>
      <g>
        <path
          d={roundedRect}
          fill={`url(#${idE})`}
          transform="translate(-71.8155 -18.1429)"
        />
        <path
          d={roundedRect}
          fill={`url(#${idF})`}
          transform="translate(-71.8155 -18.1429)"
        />
        <path
          d={roundedRect}
          fill={`url(#${idG})`}
          transform="translate(-71.8155 -18.1429)"
        />
        <path
          d={roundedRect}
          fill={`url(#${idH})`}
          transform="translate(-71.8155 -18.1429)"
        />
        <path
          fill="#fff"
          d="M132.3452 33.973c-26.7167 0-30.0696.1167-40.5629.5939-10.4727.4792-17.6212 2.136-23.8762 4.567-6.4701 2.5107-11.9586 5.8693-17.4265 11.3352-5.472 5.464-8.8332 10.9483-11.354 17.4116-2.4389 6.2524-4.099 13.3976-4.5703 23.8585-.4693 10.4854-.5923 13.8379-.5923 40.5348 0 26.697.1189 30.0371.5943 40.5225.4817 10.465 2.1397 17.6082 4.5703 23.8585 2.5147 6.4654 5.8758 11.9497 11.3458 17.4136 5.466 5.468 10.9544 8.8349 17.4204 11.3456 6.259 2.4309 13.4097 4.0877 23.8803 4.567 10.4933.477 13.8441.5938 40.5588.5938 26.7188 0 30.0615-.1167 40.5547-.5939 10.4728-.4792 17.6295-2.136 23.8885-4.567 6.4681-2.5106 11.9484-5.8775 17.4143-11.3455 5.472-5.4639 8.8332-10.9482 11.354-17.4115 2.4183-6.2524 4.0784-13.3976 4.5703-23.8585.4713-10.4854.5943-13.8277.5943-40.5246 0-26.697-.123-30.0473-.5943-40.5328-.4919-10.465-2.152-17.6081-4.5703-23.8584-2.5208-6.4654-5.882-11.9498-11.354-17.4137-5.4721-5.468-10.9442-8.8266-17.4204-11.3353-6.2714-2.4309-13.424-4.0877-23.8967-4.5669-10.4933-.4772-13.8339-.5939-40.5588-.5939zm-8.825 17.7147c2.6193-.0041 5.5418 0 8.825 0 26.2659 0 29.379.0942 39.7513.5652 9.5915.4383 14.7971 2.0397 18.2648 3.3852 4.5908 1.7817 7.8638 3.9116 11.3048 7.3521 3.4431 3.4406 5.5745 6.7173 7.3617 11.3046 1.3465 3.461 2.9512 8.6628 3.3877 18.2472.4714 10.3625.5739 13.4754.5739 39.7095 0 26.234-.1025 29.347-.5739 39.7095-.4386 9.5843-2.0412 14.7861-3.3877 18.2471-1.783 4.5874-3.9186 7.8539-7.3617 11.2923-3.443 3.4406-6.712 5.5704-11.3048 7.3521-3.4636 1.3517-8.6733 2.949-18.2648 3.3873-10.3702.471-13.4854.5734-39.7513.5734-26.2679 0-29.381-.1024-39.7513-.5734-9.5914-.4423-14.797-2.0438-18.2668-3.3893-4.5908-1.7817-7.87-3.9116-11.313-7.3521-3.4431-3.4405-5.5745-6.709-7.3617-11.2985-1.3465-3.461-2.9512-8.6628-3.3877-18.2471-.4714-10.3626-.5657-13.4754-.5657-39.7259 0-26.2504.0943-29.347.5657-39.7095.4386-9.5844 2.0412-14.7861 3.3877-18.2512 1.783-4.5874 3.9186-7.8641 7.3617-11.3046 3.443-3.4406 6.7222-5.5704 11.313-7.3562 3.4677-1.3517 8.6754-2.949 18.2668-3.3894 9.075-.4096 12.5919-.5324 30.9264-.553zm61.3363 16.322c-6.5173 0-11.805 5.2776-11.805 11.792 0 6.5125 5.2877 11.7962 11.805 11.7962 6.5172 0 11.8049-5.2837 11.8049-11.7962 0-6.5124-5.2877-11.796-11.805-11.796zm-52.5113 13.7826c-27.8993 0-50.5191 22.6031-50.5191 50.4817 0 27.8786 22.6198 50.4714 50.5191 50.4714s50.511-22.5928 50.511-50.4714c0-27.8786-22.6137-50.4817-50.513-50.4817zm0 17.7147c18.109 0 32.7914 14.6694 32.7914 32.767 0 18.0956-14.6824 32.767-32.7914 32.767-18.111 0-32.7913-14.6714-32.7913-32.767 0-18.0976 14.6803-32.767 32.7913-32.767z"
        />
      </g>
    </svg>
  )
}
